const config={

  "dropdowns":[
    {"title":"EXCHANGES","rows":[
      {"title":"Uniswap","url":"https://app.uniswap.org/#/swap?outputCurrency=0x0a59f69075b0c17a57c208471d0adb99ff368471"},
      
    ]},
   
    {"title":"COMMUNITY","rows":[
      {"title":"Discord","url":"https://discord.gg/wgst7qM5n3"},
      
    ]}
    
  ]

}
export default config;
